<template>
  <div class="orderItemWrapper" id='printBody'>
    <div class="header">
      <div class="title">
        <!-- <span>已发送给供应商：{{orderInfo ? orderInfo.supplier_name : ''}}</span> -->
        
        <div class="checked_box">
          <el-checkbox v-model="checked" @change='isChoice(checked)'></el-checkbox>
        </div>
        <!-- <div class="operBtn" @click='openPrint'>
          <span><i class="el-icon-printer"></i> 打印</span>
        </div> -->
        <!-- <div class="outStockBtn" @click='outStock' v-if="business == 'seller' && showOutBtn">
          <span><i class="el-icon-truck"></i>出库</span>
        </div> -->
        <!-- <div class="importStockBtn" @click='importStock' v-if="business == 'buyer' && orderInfo.manual_flag == 1 && showImportBtn">
          <span><i class="el-icon-truck"></i>入库</span>
        </div> -->
        <!-- <div class="deliver_goods" v-if="business == 'seller'">
          <span @click="deliverGoods" v-if="orderInfo.status == 1"><i class="el-icon-truck"></i>发货</span>
          <span v-if="orderInfo.status == 2">已发货</span>
          <span v-if="orderInfo.status == 2" class="see" @click="viewLogistics">查看</span>
        </div> -->
        <div class="order_box">
          <span class="buyer_box" v-if="business == 'seller' || business == 'product'" style="cursor: pointer;" :title="orderInfo.name" @click="searchKeyWord(orderInfo.name)">客户：{{orderInfo.name}}</span>
          <span class="seller_box" v-if="business == 'buyer'" :title="orderInfo.supplier_name">供货方：{{orderInfo.manual_flag == 1 ? orderInfo.s_name : orderInfo.supplier_name}}</span>
          <span class="phone_box" :title="orderInfo.phone"><!-- {{business == 'seller'?'发货电话：':'收货电话：'}} -->电话：{{orderInfo.phone}}</span>
          <span class="address_box" :title="orderInfo.address"><!-- {{business == 'seller'?'发货地址：':'收货地址：'}} -->地址：{{orderInfo.address ? orderInfo.address : ''}}</span>
          <span class="remark_box" :title="orderInfo.remark">备注：{{orderInfo.remark ? orderInfo.remark : ''}}</span>
        </div>
      </div>
      <div class="operation">
        <!-- <span
          :class="{ 'btn': orderInfo && orderInfo.status == 3 }"
          @click="checkLogistic"
        >
          {{orderInfo && orderInfo.status == 2 ? '查看物流' : statusName(orderInfo.status)}}
        </span> -->
        <div class="deliver_goods_box"> 
          <span v-if="orderInfo.status == 2 || orderInfo.status == 5">已发货</span>
          <span v-if="orderInfo.status == 2 || orderInfo.status == 5" @click="viewLogistics" style="cursor: pointer;">查看</span>
        </div>
        <!-- 订单状态转移 -->
        <div class="transfer_box" v-if="business == 'seller' && orderInfo.status_mark != 0">
          <div class="transfer_img_box" @mouseover="transferImgUrlTrans($event)" @mouseleave="transferImgUrlBack($event)">
            <img :src="transferImg" alt="" @click="transferOrderState">
            <span @click="transferOrderState" style="cursor: pointer;">转移</span>
          </div>
            
          <div class="transfer_content_box" v-show="orderStateIsShow" @click="OrderStateHideMask">
              <div class="triangle_box"></div>
              <div class="order_state_box">
                <div v-for="item in orderStateArr" :key="item.id" @click="stateTriangle(item.id)">{{item.name}}</div>
              </div>
          </div>
        </div>
        <!-- 采购单转发 -->
        <div class="forwardOrder" v-if="business == 'buyer'">
          <div style="display:flex;align-item:center;cursor: pointer;" @click="forwardOrderOrder" @mouseover="forwardImgUrlTrans($event)" @mouseleave="forwardImgUrlBack($event)">
            <el-tooltip class="item" effect="dark" content="转发订单" placement="bottom-start"><img :src="forwardImg" alt=""></el-tooltip>
          </div>
          <div class="forwardOrder_content_box" v-show="forwardOrderIsShow" @click="OrderStateHideMask">
              <div class="forwardOrder_box"></div>
              <p>订单转发</p>
              <div class="forwardOrderSerach">
                <div class="forwardOrderSerachInput" :style="{border:borderShow?'1px solid #6376f7':'1px solid #B2B2B2'}"><img src="../../assets/newsearch.png" alt=""><input @focus="borderShow = true" @blur="borderShow = false" v-model="forwardPhone" @keyup.enter="forwardOrderFn('')" placeholder="请输入对方柜柜账号" type="text" name="" id=""><img @click="forwardPhone = ''" v-if="forwardPhone" src="../../assets/searchclose.png" alt=""></div>
                <div class="forwardOrderSerachBtn" @click="forwardOrderFn('')">转发</div>
              </div>
              <div class="forwardSupplierBox">
                <p>供应商列表</p>
                <div class="forwardSuplierList">
                  <p v-for="item in forward" :key="item.id" @click="forwardOrderFn(item)">{{item.name}}<span :style="{color:item.supplier_uid?'':'#FB3C3C',display:'inline-block',marginLeft:'20px'}">{{item.supplier_uid?item.phone:"(未绑定柜柜账号)"}}</span></p>
                </div>
              </div>
          </div>
        </div>
        <!-- 订单编辑 -->
        <div class="edit_box" v-if="business != 'product'">
          <div @mouseover="editImgUrlTrans($event)" @mouseleave="editImgUrlBack($event)" v-if="business == 'seller' || business == 'buyer' && orderInfo.manual_flag == 1">
            <el-tooltip class="item" effect="dark" content="编辑订单" placement="bottom-start">
              <img class="edit_img" @click="toDetail" :src="modifyImgUrl" alt="">
            </el-tooltip>
          </div>
        </div>
        <!-- 订单删除 -->
        <div class="delete_box" v-if="business != 'product'">
          <div @mouseover="deleteImgUrlTrans($event)" @mouseleave="deleteImgUrlBack($event)">
            <el-tooltip class="item" effect="dark" content="删除订单" placement="bottom-start">
              <img class="delete_img" :src="deleteImgUrl" alt="" @click="deleteItem">
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!-- 关联的采购单状态 -->
    <div class="buyerStatus">
      <div>
        <p v-if="!showImportBtn && business == 'buyer' && orderInfo.manual_flag == 1" style="color: rgba(16, 193, 69, 1);">已入库</p>
        <p v-if="!showOutBtn && business == 'seller'" style="color: rgba(16, 193, 69, 1);">已出库</p>
      </div>
      <div v-if="business == 'seller'">
        <div v-for="item in aboutImportOrderInfo" :key="item.order_id">
          <u style="cursor: pointer;" class="buyerName" @click="toBuyOrder(item.order_id)">
            {{item.supplier_name}}&nbsp;&nbsp;&nbsp;
            <span>{{item.user_order_code}}</span>
          </u>
          <span class="buyOrderStatus" :style="{color:item.is_stock?'rgba(243, 104, 0, 1)':'#6376F7'}">{{item.is_stock?'已入库':'未入库'}}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- <div v-for="item in orderInfo.goods" :key="item.id">
        <img :src="item.img" alt="">
        <div class="orderDesc">
          <div class="info">
            <div>材质：{{item.material}}</div>
            <div>厚度：{{item.thick}}</div>
            <div>颜色：{{item.color}}</div>
            <div>规格：{{item.specification}}</div>
          </div>
          <div class="count">x{{item.count}}</div>
        </div>
      </div> -->
      
      <div v-if="cabinetList.length != 0">
        <div class="goodsTitle">柜体商品</div>
        <div class="goods_table_box">
          <el-table
            :data="this.cabinetList" 
            border 
            style="width: 100%;"
            :header-cell-style="tableHeaderColor"
            :cell-style="tableCellStyle"
            :row-class-name="tableRowClassName">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width="70">
            </el-table-column>
            <el-table-column
              prop="height_scope"
              label="厚度">
            </el-table-column>
            <el-table-column
              prop="width_scope"
              label="宽度">
            </el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              width="70">
              <template slot-scope="scope">
                <span>{{Number(scope.row.count).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="unit_price"
              label="单价">
            </el-table-column>
            <el-table-column
              prop="total_price"
              label="金额">
              <template slot-scope="scope">
                <span>{{(Number(scope.row.count) * Number(scope.row.unit_price)).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="shutterList.length != 0">
        <div class="goodsTitle">门窗商品</div>
        <div class="goods_table_box">
          <el-table
            :data="this.shutterList" 
            border 
            style="width: 100%;"
            :header-cell-style="tableHeaderColor"
            :cell-style="tableCellStyle"
            :row-class-name="tableRowClassName">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width="70">
            </el-table-column>
            <el-table-column
              prop="height_scope"
              label="厚度">
            </el-table-column>
            <el-table-column
              prop="width_scope"
              label="宽度">
            </el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              width="70">
              <template slot-scope="scope">
                <span>{{Number(scope.row.count).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="unit_price"
              label="单价">
            </el-table-column>
            <el-table-column
              prop="total_price"
              label="金额">
              <template slot-scope="scope">
                <span>{{(Number(scope.row.count) * Number(scope.row.unit_price)).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="furnitureList.length != 0">
        <div class="goodsTitle">家具商品</div>
        <div class="goods_table_box">
          <el-table
            :data="this.furnitureList" 
            border 
            style="width: 100%;"
            :header-cell-style="tableHeaderColor"
            :cell-style="tableCellStyle"
            :row-class-name="tableRowClassName">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width="70">
            </el-table-column>
            <el-table-column
              prop="height_scope"
              label="厚度">
            </el-table-column>
            <el-table-column
              prop="width_scope"
              label="宽度"
              >
            </el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              width="70">
              <template slot-scope="scope">
                <span>{{Number(scope.row.count).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="unit_price"
              label="单价">
            </el-table-column>
            <el-table-column
              prop="total_price"
              label="金额">
              <template slot-scope="scope">
                <span>{{(Number(scope.row.count) * Number(scope.row.unit_price)).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="woodenDoorList.length != 0">
        <div class="goodsTitle">木门商品</div>
        <div class="goods_table_box">
          <el-table
            :data="this.woodenDoorList" 
            border 
            style="width: 100%;"
            :header-cell-style="tableHeaderColor"
            :cell-style="tableCellStyle"
            :row-class-name="tableRowClassName">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width="70">
            </el-table-column>
            <el-table-column
              prop="height_scope"
              label="厚度">
            </el-table-column>
            <el-table-column
              prop="width_scope"
              label="宽度"
              >
            </el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              width="70">
              <template slot-scope="scope">
                <span>{{Number(scope.row.count).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="unit_price"
              label="单价">
            </el-table-column>
            <el-table-column
              prop="total_price"
              label="金额"
            >
              <template slot-scope="scope">
                <span>{{(Number(scope.row.count) * Number(scope.row.unit_price)).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="otherList.length != 0">
        <div class="goodsTitle">其他商品</div>
        <div class="goods_table_box">
          <el-table
            :data="this.otherList" 
            border 
            style="width: 100%;"
            :header-cell-style="tableHeaderColor"
            :cell-style="tableCellStyle"
            :row-class-name="tableRowClassName">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width="70">
            </el-table-column>
            <el-table-column
              prop="height_scope"
              label="厚度">
            </el-table-column>
            <el-table-column
              prop="width_scope"
              label="宽度"
              >
            </el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              width="70">
              <template slot-scope="scope">
                <span>{{Number(scope.row.count).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="unit_price"
              label="单价">
            </el-table-column>
            <el-table-column
              prop="total_price"
              label="金额">
              <template slot-scope="scope">
                <span>{{(Number(scope.row.count) * Number(scope.row.unit_price)).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- <div class="invalid_mask" v-if="orderInfo.delete_flag == 1">
        <div class="invalid_box">
          <p>该商品已下架 !</p>
        </div>
      </div> -->
    </div>
    
    <div class="footer">
      <!-- <span>￥{{orderInfo && orderInfo.totalPrice}}</span>
      <span>{{orderInfo && orderInfo.goods.length}}种板材</span> -->
      <div class="footer_content">
        <!-- 公用 -->
        <div class="footer_left">
          <span class="title">{{orderInfo.manual_flag == 1 ? '录入' : '商城'}}</span><span>{{orderInfo.create_time }}</span>
          <!--  | dateFilter 相对时间-->
        </div>
        <div class="orderStaffName" @click="searchKeyWord(orderInfo.staff_name)">
          {{orderInfo.staff_name}}
        </div>
        <div class="footer_right" v-if="business == 'seller' || business =='buyer'">
          <span :title='cost'>金额:￥{{cost}}</span>
          <!-- <span :title='orderInfo.discount_cost'>抵用券:{{orderInfo.discount_cost}}</span> -->
          <!-- <span :title='orderInfo.final_cost'>合计金额:<span>￥{{orderInfo.final_cost}}</span></span> -->
          <span :title='orderInfo.final_cost'>折后:<span class="amount_after_discount">￥{{orderInfo.final_cost}}</span></span>
          <!-- 销售单（手动添加）兼容 -->
          <span>{{business == 'seller' ? '已收款:￥' : '已付款:￥'}} {{orderInfo.paid}}</span>
          <span>余款:￥{{orderInfo.unpaid}}</span>
          <!-- <span class="collection_records" @click="collectionRecordsShow">{{business == 'seller' ? '收款记录' : '付款记录'}}<span>({{orderInfo.pay_list && orderInfo.pay_list.length}})</span></span> -->
          <!-- <div v-if="orderInfo.status_mark == 0 && business == 'seller'" class="acceptance_box" @click="acceptance">
            受理
          </div> -->
          <!-- <div 
            class="collection_and_paymentbtn_box"
            v-else-if="business == 'seller' && orderInfo.unpaid > 0 || 
            business == 'buyer' && orderInfo.unpaid > 0 && orderInfo.manual_flag == 1"
            @click="collectionBoxShow(orderInfo.id)">
            {{business == 'seller' ? '添加收款' : '添加付款'}}
          </div> -->
          <div 
            class="collection_and_paymentbtn_box" 
            v-if="orderInfo.unpaid != 0 && business == 'buyer' && orderInfo.manual_flag != 1" 
            @click="paymentShown(orderInfo.id)">
            立即支付
          </div>
          <div 
            class="collection_and_paymentbtn_box" 
            v-if="orderInfo.status == 2 && business == 'buyer' || orderInfo.status == 5 && business == 'buyer'" 
            @click="confirmReceipt(orderInfo.id,orderInfo.uid)">
            确认收货
          </div>
        </div>
        <!-- <span
          :class="{ 'btn': orderInfo && orderInfo.status == 3 }"
          @click="checkLogistic"
        >
          {{orderInfo && orderInfo.status == 2 ? '查看物流' : statusName(orderInfo.status)}}
        </span> -->
        <!-- 采购单 （手动添加）-->
        <!-- <span v-if="business == 'buyer' && orderInfo.manual_flag == 1">已付款：￥{{orderInfo.paid ? orderInfo.paid : 0}}</span>
        <span v-if="business == 'buyer' && orderInfo.manual_flag == 1">尾款：￥{{orderInfo.unpaid ? orderInfo.unpaid : orderInfo.final_cost}}</span>
        <el-button v-if="business == 'buyer' && orderInfo.manual_flag == 1 && orderInfo.status == 4 || 
          business == 'buyer' && orderInfo.status == 0  && orderInfo.manual_flag == 1"  
          @click="collectionBoxShow(orderInfo.id)">
          添加付款
        </el-button>
        <span v-if="business == 'buyer' && orderInfo.manual_flag == 1" class="collection_records" @click="collectionRecordsShow">付款记录<span>({{collectionRecordsCount}})</span></span> -->
      </div>
      <!-- <el-button v-if="orderInfo.status == 1 && business == 'seller'" @click="confirmShipment(orderInfo.id,orderInfo.supplier_id)">确认发货</el-button> -->
    </div>
    <!-- 添加（修改）收付款 -->
    <!-- <div class="collectionAndPaymentMask" v-if="collectionIsShow" @click="hideMask">
      <div class="collection_box">
        <div class="title_box">
          <span v-if="business == 'seller'">
            <span>{{isModify ? '修改当前收款记录' : '添加收款(手动收款)'}}</span> 
            <span v-if="!isModify">应收金额:{{orderInfo ? orderInfo.unpaid : orderInfo.final_cost}}</span>
          </span>
          <span v-else>
            <span>{{isModify ? '修改当前付款记录' : '添加付款(手动付款)'}}</span>
            <span v-if="!isModify">应付金额:{{orderInfo ? orderInfo.unpaid : orderInfo.final_cost}}</span>
          </span>
        </div>
        <div class="amount_collected_box">
          <span><span style="color:red">* </span>{{business == 'seller' ? '收款金额：' : '付款金额：'}}</span>
          <input type="Number" v-model="amountCollected" :placeholder="business == 'seller' ? '请输入收款金额' : '请输入付款金额'" @input="changeInput($event)">
          <span v-if="!isModify" :style="(monitoringAmount + monitoringOdd) >= orderInfo.unpaid ? 'color:green' : 'color:red'">{{(monitoringAmount + monitoringOdd) >= orderInfo.unpaid ? '已付清' : '未付清'}}</span>
        </div>
        <div class="amount_collected_box" v-if="business == 'seller' && !isModify">
          <span><span style="color:red"></span>去零头</span>
          <input type="Number" v-model="oddChange" placeholder="请输入零头" @input="oddInput($event)">
        </div>
        <div>
          <span><span style="color:red">* </span>{{business == 'seller' ? '收款账户：' : '付款账户：'}}</span>
          <el-select v-model="value" placeholder="请选择账户">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
          </el-select>
          <span class="account_set" @click="accountSetShow">设置...</span>
        </div>
        <div class="date_collection_box">
          <span><span style="color:red">* </span>{{business == 'seller' ? '收款日期：' : '付款日期：'}}</span>
          <el-date-picker
            v-model="timeValue"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="remarks_box">
          <span>备注：</span>
          <textarea rows="5" cols="20" name="message" v-model="collectionRemarks"></textarea>
        </div>
        <el-button v-if="!isModify" @click="confirmCollection">确认添加</el-button>
        <el-button v-else @click="modifyCollection">保存</el-button>
      </div> 
    </div> -->
    <!-- 收付款账户 -->
    <!-- <div class="accountSetMask" v-show="accountSetIsShow" @click="accountSetHideMask">
      <div class="account_box">
        <div class="title_box"><span>收款账户</span></div>
        <div class="account_content_box">
          <div v-for="item in accountArr" :key="item.id">
            <span>{{item.account}}</span><span class="delete" @click="deleteAccount(item.id)">删除</span>
          </div>
        </div>
        <div class="add_accound_box">
          <input type="text" v-model="account" placeholder="请输入账户">
          <span @click="addAccount">+ 添加账户</span>
        </div>
      </div>
    </div> -->
    <!-- 收款记录 -->
    <!-- <div class="mask" v-show="collectionRecordsIsShow" @click="collectionRecordsHideMask">
      <div class="collection_records_box">
         <div class="title_box"><span>收款记录</span></div>
         <div class="collection_records_content_box">
            <div v-for="item in this.orderInfo.pay_list" :key="item.id">
              <span>{{orderInfo.manual_flag == 1 ? item.pay_detail : item.pay_way}}</span>
              <span>{{item.pay_time}}</span>
              <span>{{item.pay_method == '线下' ? '录入' : '线上支付'}}</span>
              <span>￥{{item.pay_money}}</span>
              <span :title="item.remark" class="records_remark_box">备注：{{item.remark}}</span>
              <span>
                <span 
                  v-if="item.pay_method == '线下' && business == 'seller' || orderInfo.manual_flag == 1 && business == 'buyer'"
                  style="color:#6376f7;cursor: pointer;" 
                  @click="modifyCollectionRecords(item)">
                  编辑
                </span>
                <span
                  v-if="item.pay_method == '线下' && business == 'seller' || orderInfo.manual_flag == 1 && business == 'buyer'"
                  style="color:red;cursor: pointer;"
                  @click="deleteCollection(item)">
                  删除
                </span>
              </span>
           </div>
         </div>
      </div>
    </div> -->
    <!-- <div class="mask" v-show="logisticsIsShow" @click="logisticsHideMask">
      <div class="logistics_box">
        <div class="title_box"><span>点击发货，自动产生出库单</span></div>
        <div class="logistics_company_box">
          <span>物流公司：</span>
          <input type="text" v-model="logisticsCompany">
        </div>
        <div class="goods_checking_telephone_box">
          <span>查货电话：</span>
          <input type="text" v-model="goodsPhone">
        </div>
        <div class="logistics_order_no_box">
          <span>物流单号：</span>
          <input type="text" v-model="orderNumber">
        </div>
        <el-button @click="confirmShipment">确认发货</el-button>
      </div>
    </div> -->
    <!-- 物流信息修改 -->
    <!-- <div class="mask" v-show="viewLogisticsIsShow" @click="viewLogisticsHideMask">
      <div class="logistics_box">
        <div class="title_box"><span>查看发货信息</span></div>
        <div class="logistics_company_box">
          <span>物流公司：</span>
          <input type="text" v-model="modifyLogisticsCompany">
        </div>
        <div class="goods_checking_telephone_box">
          <span>查货电话：</span>
          <input type="text" v-model="modifyGoodsPhone">
        </div>
        <div class="logistics_order_no_box">
          <span>物流单号：</span>
          <input type="text" v-model="modifyOrderNumber">
        </div>
        <el-button @click="modifyLogistics">保存信息</el-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {handlePartOutImportStock,handleForwardData} from '../../util/processingData'
// import { saveBill,sellerBuyerBindOrderId } from '../../util/requests'
const statusMap = {
  0: '待付款',
  1: '待发货',
  2: '待收货',
  3: '已完成',
}
export default {
  components: {
  },
  // props: {
  //   'orderInfo': {},
  //   business: '',
  //   'forward': [],
  // },
  props:['orderInfo','business','forward'],
  computed: {
     ...mapState([
      'userInfo','supplierInfo'
    ]),
    stockStatus(){
      return (num,outCount) => {
        let stock = num || 0
        let cha = num - outCount
        if(cha >= 0){
          // 库存充足
          return 1
        }else{
          return 0
        }
      }
    },
    supplier_id(){
      if(this.$store.state.supplierInfo){
          return this.$store.state.supplierInfo.id
      }else{
          return 0
      }
    },
    statusName() {
      return (status) => {
        return statusMap[status];
      }
    },
    /* handleCurrentChange(val) {
    // console.log('判断是否下架',val)
    if(val.delete_flag == 1){
      this.currentRow = val;
    } */
  },
  data() {
    return {

      showImportBtn:true,
      showOutBtn:true,
      aboutImportOrderInfo:[],
      table:{
        plank:[
          {
            prop: "baseMaterial",
            label: "基材"
          },{
            prop: "color",
            label: "颜色"
          },{
            prop: "thick",
            label: "厚度"
          },{
            prop: "specification",
            label: "规格"
          },{
            prop: "texture",
            label: "钢板纹理"
          },{
            prop: "count",
            label: "数量"
          },{
            prop: "price",
            label: "单价"
          },{
            prop: "money",
            label: "金额"
          },{
            prop: "veneer",
            label: "贴面工艺"
          },{
            prop: "brand",
            label: "品牌"
          },
        ],
      },
      paymentPanelShown:false,
      wechatLink: '',
      paymentId: '',
      alipayLink: '',
      cost: '',//金额

      collectionIsShow: false,//添加收款弹框显示
      amountCollected:'',//收款金额
      options: [],
      value: '',//收款账户
      paymentMethod: '',//收款方式
      // time: '',//当前收款日期
      collectionRemarks: '',//收款备注

      accountSetIsShow: false,//账户设置弹框显示
      collectionRecordsIsShow:false,//收款记录弹框显示
      collectionRecordsCount:0,//收款记录数
      logisticsIsShow:false,//物流发货弹框显示
      logisticsCompany:'',//物流公司
      goodsPhone: '',//查货电话
      orderNumber: '',//物流单号

      viewLogisticsIsShow:false,//查看物流
      modifyLogisticsCompany: '',//修改物流公司
      modifyGoodsPhone: '',//修改查电话
      modifyOrderNumber: '',//修改订单

        accountArr: [],
        account: '',//添加的账户
        collectionRecordsArr: [],//收款记录
        //兼容各类商品
        // plankList: [],
        // hardwareList: [],
        // edgeList: [],
        // doorList: [],
        // otherList: [],
        // albumList: [],
        shutterList: [],
        furnitureList: [],
        woodenDoorList: [],
        cabinetList: [],
        otherList: [],
        /* goodsObj: {
          plankList: [],
          hardwareList: [],
          edgeList: [],
          doorList: [],
          otherList: [],
          albumList: [],
        }, */
        timeValue:'',//日期
        checked: false,//选择打印
        currentRow: null,//高亮

        monitoringAmount: 0,//监听值收付款
        monitoringOdd: 0,//监听值零头
        amountAndOdd: 0,//s收付款加零头
        oddChange: '',//零头

        isModify: false,//是否修改记录
        modifyId: '',//当前修改的记录id

        orderStateArr: [{
          id: 1,
          name: '待付款'
        },
        {
          id: 2,
          name: '未付清'
        },
        {
          id: 3,
          name: '已付清'
        },{
          id: 4,
          name: '在生产'
        },{
          id: 5,
          name: '待发货'
        },{
          id: 6,
          name: '欠货'
        },{
          id: 7,
          name: '已发货'
        },{
          id: 8,
          name: '待退款'
        },{
          id: 9,
          name: '已退款'
        },{
          id: 10,
          name: '草稿箱'
        }],//订单状态
        orderStateIsShow: false,
        forwardOrderIsShow:false,
        forwardPhone:'',
        borderShow:'',//边框

        deleteImgUrl: require('../../assets/orderQuery/deleteOrder.svg'),
        modifyImgUrl: require('../../assets/icon_edit_n@2x.png'),
        forwardImg:require('../../assets/zhuanfa-02.png'),
        transferImg: require('../../assets/transfer.png')
    }
  },
  //时间过滤
  filters:{
    dateFilter(ele){ //ele是之前记录的时间
      var lr =new Date(ele);
      var now =new Date;
      var dt =now -lr;
      var s =dt /1000;
      var m =s /60;
      var h =m /60;
      if(s <60) {
        return s +'秒前';
      }else if(s <3600) {
        return parseInt(s /60) +'分钟前';
      }else if(s <86400) {
        return parseInt(s /60 /60) +'小时前';
      }else if(s <604800) {//在一周内
          return parseInt(s /60 /60 /24) +'天前';
      }else if(s <2592000) {
          return parseInt(s /60 /60 /24 /7) +"周前"
      }else if(s <2592000 && s >604800) {//超过一周
          return parseInt(s /60 /60 /24) +'天前';
      }else if(s <31104000) {
          return parseInt(s /60 /60 /24 /30) +'月前';
      }else if(s <311040000) {
          return parseInt(s /60 /60 /24 /30 /12) +'年前';
      }
    }
  },

  methods: {
    //鼠标悬停
    deleteImgUrlTrans(e){
      this.deleteImgUrl = require('../../assets/icon_delate_hover@2x.png')
      // e.target.getElementsByTagName("delete_img").src = this.deleteImgUrl;
    },
    deleteImgUrlBack(e){
      this.deleteImgUrl = require('../../assets/orderQuery/deleteOrder.svg')
      // e.target.getElementsByTagName("delete_img").src = this.deleteImgUrl;
    },
    editImgUrlTrans(e){
      this.modifyImgUrl = require('../../assets/icon_edit_hover@2x.png')
      // e.target.getElementsByTagName("edit_img").src = this.modifyImgUrl;
    },
    editImgUrlBack(e){
      this.modifyImgUrl = require('../../assets/icon_edit_n@2x.png')
      // e.target.getElementsByTagName("edit_img").src = this.modifyImgUrl;
    },
    forwardImgUrlTrans(e){
      this.forwardImg = require('../../assets/zhuanfa-01.png')
    },
    forwardImgUrlBack(e){
      this.forwardImg = require('../../assets/zhuanfa-02.png')
    },
    transferImgUrlTrans(e){
      this.transferImg = require('../../assets/icon_transfer_s@2x.png')
    },
    transferImgUrlBack(e){
      this.transferImg = require('../../assets/transfer.png')
    },
    
    //转移订单状态
    transferOrderState(){
      this.orderStateIsShow = !this.orderStateIsShow
    },
    forwardOrderOrder(){
      this.forwardOrderIsShow = !this.forwardOrderIsShow
    },
    OrderStateHideMask(event){
      let event1 = event.currentTarget
      let event2 = event.target
      if(event1 == event2){
        this.orderStateIsShow = false
      }
    },
    // 更改已读
    updateReadStatus(){
      this.$post(`/py/erp/update_order_read_status`, JSON.stringify({
        uid: this.orderInfo.uid,
        supplier_id: this.orderInfo.supplier_id,
        order_id: this.orderInfo.id,
        status: '1',
        role: 'seller',
      }) ,res=>{
        console.log(res)
      })
    },
    //受理
    acceptance(){
       let status_mark = 1
      if(this.orderInfo.unpaid == this.orderInfo.final_cost){//未收款
        status_mark = 1
      }else if(this.orderInfo.unpaid > 0){//未收清
        status_mark = 2
      }else if(this.orderInfo.unpaid <= 0){//已收清
        status_mark = 3
      }
      // this.$emit('acceptanceOrder',id,status_mark)
      this.$post("/py/erp/update_order_status",{
        status:status_mark,
        id:this.orderInfo.id
      },res => {
        this.$message({
          message:'受理成功！',
          duration:'2000',
           type: 'success'
        })
        this.orderStateIsShow = false
        this.$emit('modifyOrderState',status_mark)
      })
    },
    //转移状态
    stateTriangle(id){
      // console.log('修改订单状态',id,this.orderInfo.id)
      this.$post("/py/erp/update_order_status",{
        status:id,
        id:this.orderInfo.id
      },res => {
        // console.log('订单状态转移',res)
        this.$message({
          message:'转移成功！',
          duration:'2000',
          type: 'success'
        })
        this.orderStateIsShow = false
        this.$emit('modifyOrderState',id)
      })
     
      // this.$emit('getOrderList')
    },



    tableRowClassName({ row }) {
      // console.log('背景色',row)
      if (row.delete_flag == 1) {
        return 'danger-row'
      }
      return ''
    },
    tableHeaderColor({row,column,rowIndex,columnIndex}){
      return 'background-color:rgba(245, 245, 245, 1);color:rgba(77, 77, 77, 1);padding: 5px 0;text-align:center;'
    },
    tableCellStyle({row,rowIndex}){
      return 'background: #FEFEFE;font-size:15px;padding: 8px 0;text-align:center;'
    },
    handleCurrentChange(val) {
    // console.log('判断是否下架',val)
    if(val.delete_flag == 1){
      this.currentRow = val;
    }
      
    },
    isChoice(value){
      // console.log(value)
      if(value){
        let storageInfo = this.printOrderInfo()
        // console.log('传的打印数据',storageInfo)
        this.$emit('yesPrint',storageInfo)
        //选择出库
        this.$emit('showOutStockBox',this.orderInfo)
      }else{
        this.$emit('noPrint',this.orderInfo.id)
      }
    },
    printOrderInfo() {
      // 先存入当前数据
     /*  const { 
         receivedFunds, totalPrice, totalCount, remainPrice, billTitle
      } = this; */
      let receivedFunds //已收
      let remainPrice //尾款 
      if(!this.orderInfo){
        receivedFunds = -1
        remainPrice = -1
      }else{
        receivedFunds = this.orderInfo.paid,//已收
        remainPrice = this.orderInfo.unpaid//尾款
      }
        let basicInfo = {
          name: this.orderInfo.name,
          phone: this.orderInfo.phone,
          address: this.orderInfo.address,
          remark: this.orderInfo.remark,
          uid:this.orderInfo.uid,
          temp_name:this.orderInfo.temp_name||""
        }
        let storageInfo = [{
          // type: this.pageType,
          uid:this.userInfo.id,
          title: '柜柜云仓销售单',
          orderId: this.orderInfo.id,
          create_time: this.orderInfo.create_time,
          type: 'sale',
          list: this.orderInfo.commodity_list,
          basicInfo,
          staffName:this.orderInfo.temp_name,
          statistics: {
            totalPrice: this.cost,//总金额
            discount_cost: this.orderInfo.discount_cost,//抵扣
            final_cost: this.orderInfo.final_cost,//折后（总计金额）
            receivedFunds: receivedFunds,//已收
            remainPrice: remainPrice//尾款
          }
        }]
        /* if(this.orderInfo.manual_flag != 1){
          storageInfo[0].receivedFunds = this.orderInfo.final_cost
          storageInfo[0].remainPrice = 0
        } */
        if(this.business == 'buyer'){
          storageInfo[0].title = '柜柜云仓采购单'
          storageInfo[0].type = 'buy'
          if(this.orderInfo.manual_flag == 1){
            basicInfo.name = this.orderInfo.s_name
          }else{
            basicInfo.name = this.orderInfo.supplier_name
          }
        }
        return storageInfo
      
      /* if(this.business == 'buyer'){
        let name
        if(this.orderInfo.manual_flag == 1){
          name = this.orderInfo.s_name
        }else{
          name = this.orderInfo.supplier_name
        }
        let basicInfo = {
          name: name,
          phone: this.orderInfo.phone,
          address: this.orderInfo.address,
          remark: this.orderInfo.remark
        }
        const storageInfo = {
          // type: this.pageType,
          title: '柜柜云仓采购单',
          list: this.orderInfo.commodity_list,
          basicInfo,
          statistics: {
            totalPrice: this.cost,//总金额
            discount_cost: this.orderInfo.discount_cost,//抵扣
            final_cost: this.orderInfo.final_cost,//折后（总计金额）
            receivedFunds: this.orderInfo.paid,//已收
            remainPrice: this.orderInfo.unpaid//尾款
          }
        }
      } */
      // console.log('/*/*',storageInfo)

     /*  const key = `print-${new Date().getTime()}`;
      window.sessionStorage.setItem(key, JSON.stringify(storageInfo));
      return key; */
    },
    restoreTmpPageInfo() {
      // 先存入当前数据
     /*  const { 
         receivedFunds, totalPrice, totalCount, remainPrice, billTitle
      } = this; */
     
        let basicInfo = {
          name: this.orderInfo.name,
          phone: this.orderInfo.phone,
          address: this.orderInfo.address,
          remark: this.orderInfo.remark

        }
        let storageInfo = [{
          // type: this.pageType,
          title: '柜柜云仓销售单',
          orderId:this.orderInfo.id,
          type: 'sale',
          list: this.orderInfo.commodity_list,
          basicInfo,
          statistics: {
            totalPrice: this.cost,//总金额
            discount_cost: this.orderInfo.discount_cost,//抵扣
            final_cost: this.orderInfo.final_cost,//折后（总计金额）
            receivedFunds: this.orderInfo.paid,//已收
            remainPrice: this.orderInfo.unpaid//尾款
          }
        }]
        if(this.business == 'buyer'){
          storageInfo[0].title = '柜柜云仓采购单'
          storageInfo[0].type = 'buy'
          if(this.orderInfo.manual_flag == 1){
            basicInfo.name = this.orderInfo.s_name
          }else{
            basicInfo.name = this.orderInfo.supplier_name
          }
        }
      const key = `print-${new Date().getTime()}`;
      window.sessionStorage.setItem(key, JSON.stringify(storageInfo));
      return key;
    },
    
    toBuyOrder(id){
      // this.$message("开发中")
      this.$router.push({
        path:`/addPurchaseOrderManually`,
        query:{
          orderId:id
        }
      })
    },
    
    toDetail(){
      // return
      // 查看手动添加的采购单详情
      if(this.business == 'buyer' && this.orderInfo.manual_flag == 1){
        this.$router.push({
          path:`/addPurchaseOrderManually`,
          query:{
            // uid:this.userInfo.id,
            // supplier_id:this.supplier_id,
            orderId:this.orderInfo.id,
          }
        })
      }
      
      if(this.orderInfo.manual_flag == 1 && this.orderInfo.status != 2 && this.showOutBtn){
        /* 编辑销售单，只允许手动添加的销售单，未发货，未出库的订单 ，情况待定*/
      }
      if(this.business == 'seller'){
        this.$router.push({
          path:`/addOrderManually`,
          query:{
            orderId:this.orderInfo.id
          }
        })
      }
    },
    // 出库
    outStock(){
      if(this.orderInfo.delete_flag == 1){
         this.$message({
          message:'该商品已下架，不可出库！',
          duration:'2000'
        })
        return
      }
      // console.log(this.orderInfo)
      let payed_money = this.orderInfo.manual_flag?this.orderInfo.paid:this.orderInfo.final_cost
      this.$emit('showOutStockBox',this.orderInfo.id)
    },
    // 入库
    importStock(){
      // this.$message("正在开发中")
      // return
      if(this.orderInfo.delete_flag == 1){//商品下架
        this.$message({
          message:'该商品已下架，不可入库！',
          duration:'2000'
        })
        return
      }
      let formData = handlePartOutImportStock(this.orderInfo.commodity_list,'import',this.supplierInfo,this.userInfo)
      formData.supplier_name = this.orderInfo.s_name
      formData.payed_money = this.orderInfo.paid
      formData.order_id = this.orderInfo.id
      // console.log(formData)
      // return
      this.$confirm('是否确定全部入库?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 入库接口，绑定采购单
          this.$requests.saveBill(formData).then((res) => {
              if (res) {
                this.$message('入库成功');
                this.$emit('getOrderList')
              }
          })
          let allBindIds = []
          this.orderInfo.commodity_list.forEach(item => {
            let bindIds = {
                id:item.commodity_id,
                bind_order_id:this.orderInfo.id,
                out_count:item.count
            }
            allBindIds.push(bindIds)
          })
          this.$requests.sellerBuyerBindOrderId(allBindIds).then(res => {

          })
        }).catch(() => {
                   
        });
    },
    //打印
    openPrint() {
      const key = this.restoreTmpPageInfo();
      window.open(`./printOrder.html?hash=${key}`);
      
      return;
      let that=this
      var userAgent = navigator.userAgent.toLowerCase(); //取得浏览器的userAgent字符串
      if (userAgent.indexOf("trident") > -1) {
        alert("请使用google或者360浏览器打印");
        return false;
      } else if (userAgent.indexOf('msie') > -1) {
        var onlyChoseAlert = simpleAlert({
          "content" : "请使用Google或者360浏览器打印",
          "buttons" : {
            "确定" : function() {
              onlyChoseAlert.close();
            }
          }
        })
        alert("请使用google或者360浏览器打印");
        return false;
      } else {//其它浏览器使用lodop
        var head=window.document.head.innerHTML;
        let headTemp=head.split(`<meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests">`)
        head=''
        // console.log('***',headTemp)
        for(let item of headTemp){
          head+=item
        }
        // console.log(head)

        head=head.replace(`<link href="./`,`<link href="https://www.guigui.com.cn/`)

        var headstr = "<html><head>"+head+"</head><body>";
        // console.log('///',headstr)
        // return
        var footstr = '</body></html>'
  
        // var printData = document.getElementById("printBody").innerHTML; //获得 div 里的所有 html 数据
        let list = this.orderInfo.commodity_list
        let a = ``
        for(let i in list){
          let index = i+1
          let substrate = list[i].substrate
          let color_name = list[i].color_name
          let thick = list[i].thick
          let spec = list[i].spec
          let texture = list[i].texture
          let count = list[i].count
          let price = list[i].price
          let money = list[i].total_price
          let veneer = list[i].texture_method
          let brand = list[i].brand_name
          let b = `<tr>
                    <td class="font-center">${index}</td>
                    <td class="font-center">${substrate}</td>
                    <td class="font-center">${color_name}</td>
                    <td class="font-center">${thick}</td>
                    <td class="font-center">${spec}</td>
                    <td class="font-center">${texture}</td>
                    <td class="font-center">${count}</td>
                    <td class="font-center">${price}</td>
                    <td class="font-center">${money}</td>
                    <td class="font-center">${veneer}</td>
                    <td class="font-center">${brand}</td>
                </tr>`
          a += b
        }
        var printData = `
            <style>
                * {
                    margin: 0;
                    padding: 0;
                }
                #vv{
                    border: 1px solid  rgba(235, 235, 235, 0.7);
                    margin: 50px;
                    padding: 0 10px;
                    border-radius: 10px;
                }
                .header {
                    width: 100%;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    border-bottom: solid 1px rgba(235, 235, 235, 0.7);
                }
                .header>span{
                    /* border: 1px solid red; */
                    margin-right: 20px;
                    display: inline-block;
                    width: 200px;
                }
                .content{
                    padding: 10px 0;
                }
                .footer{
                    width: 100%;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                }
                .footer>span{
                    /* border: 1px solid red; */
                    margin-right: 20px;
                    display: inline-block;
                    width: 120px;
                }
                .font-center{ 
                    text-align:center
                }
                table{
                    border-collapse:collapse;
                }
                table, th, td{
                    border: 1px solid #EBEEF5;
                    height: 48px;
                }
                th{
                    color: #909399;
                    font-size: 14px;
                }
                td{
                    color: #606266;
                    font-size: 14px;
                }
                
            
            </style>
            <div id="vv">
                <div class="header">
                    
                      <span>购买方：${this.orderInfo.name}</span>
                      <span>电话：${this.orderInfo.phone}</span>
                      <span>地址：${this.orderInfo.address ? this.orderInfo.address : ''}</span>
                      <span>备注：${this.orderInfo.remark ? this.orderInfo.remark : ''}</span>
                    
                </div>
                <div class="content">
                    <table width="100%" border="0" cellspacing="1" cellpadding="4" align="center">
                        <tr>
                            <th>序号</th>
                            <th>基材</th>
                            <th>板材颜色</th>
                            <th>厚度</th>
                            <th>规格</th>
                            <th>钢板纹理</th>
                            <th>数量</th>
                            <th>单价</th>
                            <th>金额</th>
                            <th>贴面工艺</th>
                            <th>品牌</th>
                        </tr>

                        `+a+`
                    </table>
                </div>`+`
                <div class="footer">
                  
                      <span>金额：${this.cost}</span>
                      <span>抵用券抵扣：${this.orderInfo.discount_cost}</span>
                      <span>合计金额：<span>￥${this.orderInfo.final_cost}</span></span>
                      <span>折后金额：￥0</span>
                      <span>已收款：￥0</span>
                      <span>尾款：￥0</span>
                    
                </div>`+`
            </div>`
            // console.log('/*/*',printData)
        var wind = window.open("", "newwin","toolbar=no,scrollbars=yes,menubar=no");
        wind.document.write(headstr + printData + footstr)
        wind.document.write("<script>window.print()</\script>")
        // console.log(wind)
        // wind.onload=function(){
        //     wind.print();
        // }






        //打印结束后，放开隐藏内容

        for (let i=0,len=printHidden.length;i<len;i++) {
              let item=printHidden[i]
              item.style.display=displayOld[i];
        }
        // that.onPrint=false
        // wind.close();
      } 
    },
    
    collectionBoxShow(id){//添加收款框显示
    // console.log('订单',id)
      this.checked = false
      this.$emit('noPrint',this.orderInfo.id)
      
      if(this.orderInfo.delete_flag == 1 && this.business == 'buyer'){
        this.$message({
          message:'该商品已下架！',
          duration:'2000'
        })
        return
      }
      this.amountCollected = ''
      this.value = ''
      this.timeValue = ''
      this.collectionRemarks = ''

      this.collectionIsShow = true
      // this.amountCollected = //获取当前应付金额
      this.getAccount()//账户
    },
    hideMask(event){//添加收款蒙板点击
      let event1 = event.currentTarget
      let event2 = event.target
      if(event1 == event2){
          this.collectionIsShow = false
          this.isModify = false
      }
    },
    confirmCollection(){//确认添加收款
    /* let data = {
      order_id: this.orderInfo.id,
      pay_way: '线下',
      pay_money: this.amountCollected,
      pay_detail: this.value,
      remark: this.collectionRemarks
    }
    this.$emit('confirmCollection',data) */
    if(this.amountCollected == ''){
      if(this.business == 'seller'){
        this.$message('请输入收款金额')
        return
      }else if(this.business == 'buyer'){
        this.$message('请输入付款金额')
        return
      }
    }
    if(this.value == ''){
      if(this.business == 'seller'){
        this.$message('请选择收款账户')
        return
      }else if(this.business == 'buyer'){
        this.$message('请选择付款款账户')
        return
      }
    }
    if(this.timeValue == ''){
      this.$message('请选择日期')
      return
    }
    // console.log('日期',this.timeValue)
    let pay_type = 1
    if(this.business == 'buyer'){
      pay_type = 2
    }
    if(this.oddChange == ''){
      this.oddChange = 0
    }
      this.$post("/py/erp/add_manual_payment",{
          order_id: this.orderInfo.id,
          supplier_id: this.supplier_id,
          uid: this.userInfo.id,
          pay_money: this.amountCollected,
          account_id: this.value,
          remark: this.collectionRemarks,
          pay_time: this.timeValue,
          pay_type: pay_type,
          odd: this.oddChange
      },res => {
        if(res.status == 1){
           if(this.business == 'seller'){
            this.$message({
              message: '添加收款成功',
              duration:'2000',
              type: 'success'
            })
            this.amountCollected = ''
            this.value = ''
            /* this.paymentMethod = '' */
            this.collectionRemarks = ''

            this.getMoney()//余款
            this.getCollectionRecords()//收付款记录

            if(res.data.finish_flag == 1){
              this.$emit('upDataOrderList')
            }
          }
          if(this.business == 'buyer'){
            this.$message({
              message: '添加付款成功',
              duration:'2000',
              type: 'success'
            })
            this.amountCollected = ''
            this.value = ''
            this.collectionRemarks = ''
            this.getMoney()
            this.getCollectionRecords()
            if(res.data.finish_flag == 1){
              this.$emit('upDataOrderList')
            }
          }
        }else if(res.status == 0){
          // console.log('收款错误',res)
          if(this.business == 'seller'){
           /*  this.$message({
              message: '添加收款成功',
              type: 'success'
            }) */
            this.$message({
              showClose: true,
              message: '添加收款失败！',
              type: 'error'
            });
           
          }
          if(this.business == 'buyer'){
            this.$message({
              showClose: true,
              message: '添加付款失败！',
              type: 'error'
            });
            
          }
        }

      })
      this.oddChange = ''
      this.collectionIsShow = false
      this.isModify = false
       
    },
    modifyCollectionRecords(item){
      // console.log('当前修改的记录',item)
      this.getAccount()//账户
      this.collectionIsShow = true
      this.isModify = true
      this.modifyId = item.id

      this.amountCollected = item.pay_money
      this.value = item.account_id
      this.timeValue = item.pay_time
      this.collectionRemarks = item.remark
      
    },
    modifyCollection(){//保存修改记录

      this.$post("/py/erp/update_manual_order_payment",{
        id: this.modifyId,
        detail: {
          account_id: this.value,
          remark: this.collectionRemarks, 
          pay_money: this.amountCollected,
          pay_time: this.timeValue
        }
      },res => {
        // console.log('修改记录',res)
        if(res.status == 1){
          this.$message({
            type: 'success',
            message: '修改成功!',
            duration: 1000
          });
        }
        this.collectionIsShow = false
        this.getCollectionRecords()
        this.getMoney()
      })

    },
    deleteCollection(item){
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$post("/py/erp/delete_manual_order_payment",{
            id: item.id,
            uid: this.userInfo.id,
            supplier_id: this.supplier_id
          },res => {
            if(res.status == 1){
              this.$message({
                type: 'success',
                message: '删除成功!',
                duration: 1000
              });
            }
              this.getCollectionRecords()

              this.getMoney()

              this.collectionIsShow = false
          })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
            duration: 1000
          });          
        });
    },

    getAccount(){
       //获取账户
      // this.axios({
      //   method: 'GET',
      //   url: 'https://ggtools.thinkerx.com/erp/get_payment_account',
      //   params:{
      //     uid: this.userInfo.id,
      //     supplier_id: this.supplier_id
      //   }
      // }).then(res => {
      //   // console.log('收款账户',res.data)
      //   this.accountArr = res.data.data

      //   let list = res.data.data
      //   let arr = []
      //   for(let i in list){
      //     arr.push(
      //       {
      //         value: list[i].account,
      //         label: list[i].account
      //       }
      //     )
      //     this.options = arr
      //   }
        
      // })
      this.$get("/py/erp/get_payment_account",{
        uid: this.userInfo.id,
        supplier_id: this.supplier_id
      },res => {  
        this.accountArr = res.data
        let list = res.data
        // console.log(list)
        let arr = []
        for(let i in list){
          arr.push(
            {
              value: list[i].id,
              label: list[i].account
            }
          )
          this.options = arr
          // console.log('账户',this.options)
        }
      })

    },
    changeInput(e){
      this.monitoringAmount = Number(e.target.value);
      this.amountAndOdd = Number(this.monitoringAmount + this.monitoringOdd)
      // console.log(this.amountAndOdd)
    },
    oddInput(e){
      this.monitoringOdd = Number(e.target.value);
      this.amountAndOdd = Number(this.monitoringOdd + this.monitoringAmount)
      // console.log(this.amountAndOdd)
    },
    accountSetShow(){
      this.accountSetIsShow = true
      this.getAccount()
    },
    addAccount(){
      // console.log('添加账号',this.account)
      if(this.account == ''){
        this.$message('账户不能为空')
        return
      }
      // this.axios({
      //   method: 'POST',
      //   url: 'https://ggtools.thinkerx.com/erp/set_payment_account',
      //   data: {
      //     uid: this.userInfo.id,
      //     supplier_id: this.supplier_id,
      //     account: this.account
      //   }
      // }).then(res => {
      //   // console.log('添加账户',res.data)
      //   if(res.data.status == 1){
      //     this.$message('添加成功')
      //     this.getAccount()
      //   }
      //   this.account = ''
      // })
      this.$post("/py/erp/set_payment_account",{
        uid: this.userInfo.id,
        supplier_id: this.supplier_id,
        account: this.account
      },res => {
        if(res.status == 1){
          this.$message('添加成功')
          this.getAccount()
        }
        this.account = ''
      })
    },

    accountSetHideMask(event){
      let event1 = event.currentTarget
      let event2 = event.target
      if(event1 == event2){
          this.accountSetIsShow = false
      }
    },
    deleteAccount(id){
      this.$confirm('此操作将永久删除该账户, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
      }).then(() => {
        // console.log('删除账号',id)
      // this.axios({
      //   method: 'POST',
      //   url: 'https://ggtools.thinkerx.com/erp/delete_payment_account',
      //     data: {
      //       uid: this.userInfo.id,
      //       supplier_id: this.supplier_id,
      //       id: id
      //     }
      //   }).then(res => {
      //     // console.log(res.data)
      //     if(res.data.status == 1){
      //       this.$message({
      //         type: 'success',
      //         message: '删除成功!'
      //       });
      //       this.getAccount()
      //     }
      //   })
        this.$post("/py/erp/delete_payment_account",{
          uid: this.userInfo.id,
          supplier_id: this.supplier_id,
          id: id
        },res => {
          if(res.status == 1){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getAccount()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
      
    },
    collectionRecordsShow(){
      this.collectionRecordsIsShow = true
      // this.getCollectionRecords()
    },
    getCollectionRecords(){//收付款记录
        let is_sales = 1
        if(this.business == 'buyer'){
          is_sales = 0
        }
        this.$post("/py/erp/get_cloud_manual_payment",{
          order_id:this.orderInfo.id,
          is_sales: is_sales,
          uid: this.userInfo.id,
          supplier_id: this.supplier_id
        },res => {
          // this.collectionRecordsArr = res.data.pay_list
          // this.collectionRecordsCount = res.data.pay_list.length
          this.orderInfo.pay_list = res.data.pay_list
        })
      
    },
    collectionRecordsHideMask(event){
      let event1 = event.currentTarget
      let event2 = event.target
      if(event1 == event2){
        this.collectionRecordsIsShow = false
      }
    },
    //物流发货
    deliverGoods(){
      this.logisticsIsShow = true
    },
   
    logisticsHideMask(event){
      let event1 = event.currentTarget
      let event2 = event.target
      if(event1 == event2){
          this.logisticsIsShow = false
      }
    },
    
    //查看物流
    viewLogistics(){
      this.viewLogisticsIsShow = true
      this.$post("/py/erp/get_cloud_order_express",{
        order_id: this.orderInfo.id,
      },res => {
        this.modifyLogisticsCompany = res.data.express_company
        this.modifyGoodsPhone = res.data.phone
        this.modifyOrderNumber = res.data.express_id
      })
    },
    modifyLogistics(){
      this.$post("/py/erp/update_cloud_order_express",{
        order_id: this.orderInfo.id,
        express_company : this.modifyLogisticsCompany,
        phone: this.modifyGoodsPhone,
        express_id: this.modifyOrderNumber
      },res => {
        if(res.status == 1){
          this.$message('保存成功')
        }
      })
      this.viewLogisticsIsShow = false
    },
    viewLogisticsHideMask(event){
      let event1 = event.currentTarget
      let event2 = event.target
      if(event1 == event2){
          this.viewLogisticsIsShow = false
      }
    },


    checkLogistic() {
      this.$emit('checkLogistic');
    },
    deleteItem() {
      let id = this.orderInfo.id
      this.$emit('delete',id);
    },
    payment(id){
     this.$emit('payment',id);
    },
    skipToOrderList() {
      clearInterval(this.queryStatusInterval);
      this.$router.replace({
        name: 'QueryOrder'
      });
    },

    //支付
    paymentShown(id) {
      // this.$message('开发中');
      // return;
       if(this.orderInfo.delete_flag == 1){
        this.$message({
          message:'该商品已下架！',
          duration:'2000'
        })
        return
      } 
      this.$emit('pay', id);
    },
    confirmReceipt(oid,uid) {
      this.$emit('confirmReceipt',oid,uid)
    },
    /* confirmShipment(oid,sid){
      this.$emit('confirmShipment',oid,sid)
    }, */
    confirmShipment(){
      this.$post("/py/erp/cloud_order_express",{
          order_id: this.orderInfo.id,
          uid: this.userInfo.id,
          supplier_id: this.supplier_id,
          manual_flag: 1,
          express_company: this.logisticsCompany,
          express_id: this.orderNumber,
          phone: this.goodsPhone
      },res => {
         if(res.status == 1){
          this.$message('发货成功')
          this.$emit('upDataOrderList')
        }
      })
      this.logisticsIsShow = false
    },
    //生成出库单
  /*   outboundOrder(){
      let detail = []
      let data = []
      
      this.axios({
        method: 'POST',
        url: 'https://ggtools.thinkerx.com/erp/commodity_storage',
        data: {
          supplier_id: this.supplierInfo.id,
          supplier_name: this.orderInfo.name,
          order_type: 2,
          detail: detail,
          data: data,
          commodity_type: 'plank',
          num:num
        }
      }).then(res => {
        console.log('生成出库单',res.data)
      })
    }, */
    cancelPayment() {
      clearInterval(this.queryStatusInterval);
      this.paymentPanelShown = false;
      // 跳转到订单页
    },
    getMoney(){//获取尾款 已收款
    let order_type = 1
    if(this.business == 'buyer'){
      order_type = 2
    }
      this.$post("/py/erp/get_order_manual_price",{
        uid: this.userInfo.id,
        supplier_id: this.supplier_id,
        order_type: order_type,
        order_id: this.orderInfo.id,
      },res => {
        // console.log('获取当前单的尾款',res)
        this.orderInfo.paid = res.data.paid
        this.orderInfo.unpaid =res.data.unpaid
      })
    },
    async forwardOrderFn(data){
      let orderInfo = this.orderInfo
      let list = []
      console.log(orderInfo.commodity_list)
      orderInfo.commodity_list.forEach(item => {
        list.push(handleForwardData(item))
      })
      let formData = {
        address:orderInfo.address,
        cost_money:Number(orderInfo.final_cost),
        customer_id:0,
        manual_flag:1,
        name:this.userInfo.name,
        phone_number:this.userInfo.phone,
        price_flag:'price',
        remark:orderInfo.remark,
        commodity_list:list,
        change_status:1
      }
      if(data){
        //选择供应商转发
        if(!data.supplier_uid){
          this.$message('该用户未绑定柜柜账号')
          return
        }else{
          // 转发
          await this.$requests.getSupplierInfo({
            uid:data.supplier_uid
          }).then(res => {
            if(res){
              formData.supplier_id = res.id
            }else{
              formData.supplier_id = 0
            }
            formData.uid = data.supplier_uid
          })
          formData.commodity_list.forEach(item => {
            item.uid = formData.uid
            item.supplier_id = formData.supplier_id
          })
          console.log(formData)
          this.$post('/py/erp/add_manual_order',formData,res => {
            if(res.status == 1){
              this.$message.success('转发成功')
              this.forwardOrderIsShow = false
            }
          })
        }
      }else{
        // 搜索转发
        this.$get("/system/wechat_app/user_info",{
          phone:this.forwardPhone
        },res => {  
          // console.log(res.data)
          if(res.data){
            // 是柜柜用户
            this.$requests.getSupplierInfo({
              uid:res.data.id
            }).then(resp => {
              formData.uid = res.data.id
              if(resp){
                // 是供应商
                // console.log(resp)
                formData.supplier_id = resp.id
              }else{
                formData.supplier_id = 0
              }
              formData.commodity_list.forEach(item => {
                item.uid = formData.uid
                item.supplier_id = formData.supplier_id
              })
              // console.log(formData)
              this.$post('/py/erp/add_manual_order',formData,resa => {
                if(resa.status == 1){
                  this.$message.success('转发成功')
                  this.forwardOrderIsShow = false
                }
              })
            })
          }else{
            this.$message('该用户还不是柜柜用户')
          }
        })
      }
    },
    searchKeyWord(key){
      this.$emit('orderItemSearch',key)
    }
  },
  mounted(){
    console.log('传递的订单信息',this.orderInfo)
    // console.log('business:',this.business)
    let goodsList = this.orderInfo.commodity_list
    for(let i in goodsList){
      switch(goodsList[i].commodity_type){
        case 'shutter':
          this.shutterList.push(goodsList[i]);
          // this.goodsObj.plankList.push(goodsList[i]);
          break;
        case 'furniture':
          this.furnitureList.push(goodsList[i]);
          // this.goodsObj.edgeList.push(goodsList[i]);
          break;
        case 'woodenDoor':
          this.woodenDoorList.push(goodsList[i]);
          // this.goodsObj.hardwareList.push(goodsList[i]);
          break;
        case 'other':
          this.otherList.push(goodsList[i]);
          // this.goodsObj.otherList.push(goodsList[i]);
          break;
        case 'cabinet':
          this.cabinetList.push(goodsList[i]);
          break;
      }
    }
    let importNedeNum = 0
    let importedNum = 0
    let isGet = 0  //是否调用bind_order 接口
    // 入库按钮是否显示
    goodsList.forEach(item => {
      isGet += item.bind_order_id
      if(item.id > 0){
        importNedeNum += item.count
        importedNum += item.out_count
      }
    })
    // console.log(importNedeNum,importedNum)
    if(importNedeNum == importedNum){
      this.showOutBtn = false
      this.showImportBtn = false
    }else{
      this.showOutBtn = true
      this.showImportBtn = true
    }
    console.log(this.showImportBtn)
    // 总数量为0，不显示库存
    if(importNedeNum == 0){
      this.showOutBtn = true
      this.showImportBtn = true
    }
    if(this.business == 'seller' && this.orderInfo.manual_flag == 1){
      if(isGet){
        this.$post("/py/erp/get_order_bind_order",{
          order_id:this.orderInfo.id
        },res => {
          if(res.data){
            this.aboutImportOrderInfo = res.data
          }
        })
      }
    }
    
    // 出库按钮是否显示

    // this.getMoney()//尾款
    /* console.log('plank',this.plankList)
    console.log('edge',this.edgeList)
    console.log('hardware',this.hardwareList)
    console.log('door',this.doorList)
    console.log('other',this.otherList) */
    // console.log('goodsObj',this.goodsObj)

    
    
    //获取当前日期
    /* var day = new Date();
    day.setTime(day.getTime());
    var s2 = day.getFullYear()+"-" + (day.getMonth()+1) + "-" + day.getDate();
    this.time = s2 */

  //  this.getCollectionRecords()

   /*  console.log('传递的',this.orderInfo) */
    let vip_cost = this.orderInfo.vip_cost
    let total_cost = this.orderInfo.total_cost
    let final_cost = this.orderInfo.final_cost
    let discount_cost = this.orderInfo.discount_cost
    this.cost = total_cost
    // if(vip_cost-discount_cost == final_cost){
    //   // console.log('会员')
    //   this.cost = vip_cost
    // }else if(total_cost-discount_cost == final_cost){
    //   // console.log('非会员')
    //   this.cost = total_cost
    //  /*  for(let i in this.orderInfo.commodity_list){
    //      this.orderInfo.commodity_list[i].unit_price = this.orderInfo.commodity_list[i].price
    //    } */
    // }else{
    //   // console.log('手动')
    //    this.cost = total_cost
    // }


    // console.log('****',this.cost)
    /* if(this.userInfo.cloud_vip == 0){
       console.log('修改值',this.orderInfo.commodity_list)
       for(let i in this.orderInfo.commodity_list){
         this.orderInfo.commodity_list[i].unit_price = 242
       }
    } */
    //  console.log('//////////////',this.orderInfo,this.userInfo)
    // 仅用微信支付
     /*  ['2'].forEach((payWay) => {
        // 获取支付链接
        const payload = {
          uid: this.userInfo.id,
          oids: [orderId],
          pay_way: payWay,
          pay_type: 'html',
          platform: 1
        }
        getPaymentLink(payload).then((res) => {
          switch(payWay) {
            case '2':
              this.wechatLink = res.codeUrl;
              break;
            default:
              break;
          }
          this.paymentId = res.payment_id;
        })
      }) */    
  }
}
</script>

<style lang="less" scoped>
.orderItemWrapper {
  width: 100%;
  border-radius: 10px;
  background-color: white;
  padding: 0 20px;

  .header {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 1px rgba(235, 235, 235, 0.7);
    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 16px;
      // border: 1px solid red;
      width: 930px;
      display: flex;
      justify-content: flex-start;
      .operBtn{
        // border: 1px solid red;
        cursor: pointer;
        margin-right: 20px;
        width: 80px;
        span{
          color: #5147e7;
        }
      }
      .outStockBtn{
        cursor: pointer;
        margin-right: 20px;
        width: 80px;
        span{
          color: #5147e7;
        }
      }
      .checked_box{
        margin-right: 20px;   
      }
      .importStockBtn{
        cursor: pointer;
        margin-right: 20px;
        width: 80px;
        span{
          color: #5147e7;
        }
      }
      .deliver_goods{
        // border: 1px solid red;
        margin-right: 20px;
        width: 160px;
        span:first-child{
          cursor: pointer;
        }
        .see{
          cursor: pointer;
          margin-left: 10px;
          font-size: 14px;
          color: #409EFF;
        }
      }
      .order_box{
        // border: 1px solid black;
        display: flex;
        align-items: center;
        >span{
          // border: 1px solid red;
          // width: 200px;
          font-size: 15px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 40px;
        }
        .order_box{

        }
        .buyer_box{

        }
        .seller_box{

        }
        .address_box{
          max-width: 250px;
        }
        .remark_box{
          display: inline-block;
          // border: 1px solid red;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 0;
        }
        .phone_box{
          
        }

      }
    }
    .operation {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 300px;
      >div{
        margin-right: 20px;
      }
      .deliver_goods_box{
        font-size: 15px;
        span:nth-child(1){
           color: #6B83AE;
           margin-right: 4px;
        }
        span:nth-child(2){
          color: #6376F7;
        }
      }
      .transfer_box{
        // display: flex;
        // align-items: center;
        position: relative;
        margin-right: 0;
        img {
          cursor: pointer;
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }
        span{
          font-size: 15px;
        }
        .transfer_img_box:nth-child(1){
          display: flex;
          align-items: center;
        }
        .transfer_img_box:nth-child(1):hover{
          color: #6376f7;
        }
        .transfer_content_box{
          // border: 1px solid red;
          position: absolute;
          top: 35px;
          right: -50px;
          width: 304px;
          // height: 200px;
          z-index: 3;
          background: #EFEFEF;
          box-shadow: 3px 6px 10px rgba(158, 158, 158, 0.73);
          border-radius: 8px;
          .triangle_box{
            position: absolute;
            top: -20px;
            right: 55px;
            border-style: solid;
            border-width: 10px 10px 10px 10px;
            border-color: transparent transparent #EFEFEF transparent;
            width: 0px;
            height: 0px;
          }
          .order_state_box{
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            flex-wrap: wrap;
            padding: 0 20px 20px;
            div{
              border: 1px solid #707070;
              color: #333333;
              width: 72px;
              height: 32px;
              line-height: 32px;
              border-radius: 4px;
              margin-top: 20px;
              cursor: pointer;
            }
            div:hover{
              border: 1px solid #6376F7;
              color: #6376F7;
              background: #E5E8FF;
            }
          }
        }
       
      }
      .forwardOrder{
        display: flex;
        align-items: center;
        // border: 1px solid red;
        position: relative;
        margin-right: 0;
        img {
          cursor: pointer;
          width: 18px;
          height: 18px;
          // margin-right: 4px;
          // margin: 0 20px;
        }
        span{
          font-size: 15px;
        }
        .forwardOrder_content_box{
          // border: 1px solid red;
          position: absolute;
          top: 35px;
          right: -50px;
          z-index: 3;
          background: #EFEFEF;
          box-shadow: 3px 6px 10px rgba(158, 158, 158, 0.73);
          border-radius: 8px;
          padding: 30px 20px 20px;
          >p{
            margin-bottom: 16px;
            font-weight: bold;
            color: #333;
            text-align: center;
            font-size: 15px;
          }
          .forwardOrder_box{
            position: absolute;
            top: -20px;
            right: 55px;
            border-style: solid;
            border-width: 10px 10px 10px 10px;
            border-color: transparent transparent #EFEFEF transparent;
            width: 0px;
            height: 0px;
          }
          .forwardOrderSerach{
            display: flex;
            align-items: center;
            .forwardOrderSerachInput{
              width: 290px;
              padding: 0 3px;
              display: flex;
              align-items: center;
              
              border-radius: 6px;
              background-color: #fff;
              height: 30px;
              >input{
                width: 240px;
                height: 24px;
                outline: none;
                border: none;
              }
              >img{
                width: 16px;
                height: 16px;
              }
            }
            .forwardOrderSerachBtn{
              width: 60px;
              line-height: 30px;
              text-align: center;
              color: #fff;
              background-color: #6376F7;
              margin-left: 10px;
              border-radius: 6px;
              cursor: pointer;
            }
          }
          .forwardSupplierBox{
            margin-top: 10px;
            text-align: left;
            >p{
              color: #878787;
            }
            .forwardSuplierList{
              >p{
                padding: 14px 0;
                border-bottom: 1px solid #B2B2B2;
                cursor: pointer;
                &:hover{
                  color: #6376F7;
                }
              }
            }
          }
          
        }
      }
      .edit_box{
        display: flex;
        align-items: center;
        img {
          cursor: pointer;
          width: 24px;
          height: 24px;
        }
        .edit_img{
          margin-left: 20px;
        }
      }
      .delete_box{
        display: flex;
        align-items: center;
        margin-right: 0;
        img {
          cursor: pointer;
          width: 24px;
          height: 24px;
        }
        .delete_img{
          // margin-left: 20px;
        }
      }
      
      // span{
      //   font-size: 15px;
      //    margin-right: 8px;
      // }
      // span:nth-child(1){
      //   margin-right: 20px;
      // }
      // span:nth-child(2){
      //   color: #6B83AE;
      // }
      // span:nth-child(3){
      //   color: #6376F7;
      //   cursor: pointer;
      //   margin-right: 20px;
      // }
      /* span {
        font-size: 16px;
        color: rgba(72, 72, 72, 1);
        pointer-events: none;
      }
      span.btn {
        cursor: pointer;
        color: rgba(81, 71, 231, 1);
        pointer-events: auto;
      } */

    }
    
  }
  .buyerStatus{
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
    >div{
      margin-right: 20px;
      >div{
        >u{
          display: inline-block;
          &.buyerName{
            cursor: pointer;
            margin-right: 5px;
          }
        }
      }
    }
    >div:last-child{
      margin-right: 0;
    }
  }
 /*  .content{
    .el-table .cell{
      text-align: center;
      min-height:15px;
    }
  } */

  .content {
    // width: 1070px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 20px;
    display: flex;
    flex-flow: column;
    position: relative;
    background: rgba(217, 217, 217, 1);
    // border: 1px solid red;
    // .el-table .cell{
    //   text-align: center;
    //   min-height:15px;
    // }
    // cursor: pointer;
    > div /deep/ .el-table .danger-row {
      background-color:#F2F2F2;
    }
    > div /deep/ .el-table .el-table_header {
      margin: 0;
    }
    >div{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background:rgba(245, 245, 245, 1);
      // border: 1px solid red;
      .goods_table_box{
        width: 100%;
        // border: 1px solid red;
      }
      .goodsTitle{
        writing-mode: vertical-lr;
        padding: 5px 7px;
        width: 36px;
        color: #333333;
        // border: 1px solid red
      }
    }
    
    // .invalid_mask{
    //   position: absolute;
    //   bottom: 0;
    //   left: 0;
    //   z-index: 1;
    //   width: 100%;
    //   height: 100%;
    //   background-color: rgba(51, 51, 51, 0.4);
    //   div{
    //     color: #ffffff;
    //     position: relative;
    //     top: 50%;
    //     transform: translateY(-50%);
    //     font-size: 20px;
    //     font-size: 20px;
    //     font-weight: bold;
    //   }
    // }
    
  }
  .footer{
    margin-top: 20px;
    padding: 20px 0;
    border-top: 1px solid rgba(235, 235, 235, 1);
    .footer_content{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .orderStaffName{
        cursor: pointer;
        color: #000;
      }
      .footer_left{
        span{
          font-size: 13px;
          color: rgba(102, 102, 102, 1);
        }
        .title{
          font-size: 15px;
          color: rgba(107, 131, 174, 1);
          font-style:italic;
          font-weight: bold;
          margin-right: 12px;
        }
      }
      .footer_right{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        >span{
          font-size: 15px;
          margin-right: 20px;
        }
        .amount_after_discount{
          color: red;
        }
        .collection_records{
          color: rgba(99, 118, 247, 1);
        }
        .collection_records{
          cursor: pointer;
        }
        .collection_records{
          margin-right: 12px;
          margin-left: 8px;
        }
        .collection_and_paymentbtn_box{
          width: 80px;
          height: 32px;
          line-height: 32px;
          font-size: 15px;
          border-radius: 6px;
          cursor: pointer;
          background: rgba(99, 118, 247, 1);
          color: rgba(255, 255, 255, 1);
          margin-left: 10px;
        }
        .acceptance_box{
          width: 60px;
          height: 32px;
          line-height: 32px;
          font-size: 15px;
          border-radius: 6px;
          cursor: pointer;
          background: rgba(99, 118, 247, 1);
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
    .collectionAndPaymentMask{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 3;
      background-color: rgba(51, 51, 51, 0.5);
      .collection_box{
        width: 420px;
        // height: 350px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        padding-bottom: 20px;
        div{
          // border: 1px solid red;
          text-align: left;
          padding-left: 10px;
        }
        .title_box{
          text-align: left;
          padding: 10px;
          margin-bottom: 10px;
          >span{
            >span:nth-child(2){
              margin-left: 40px;
            }
          }
        }
        .amount_collected_box{
          >span:nth-of-type(2){
            margin-left: 10px;
          }
        }
        div:not(:first-child){
          height: 40px;
          line-height: 40px;
          display: flex;
          justify-content: flex-start;
          margin-bottom: 20px;
          >span{
            width: 80px;
            display: inline-block;
            // border: 1px solid red;
          }
          input{
            width: 217px;
            height: 40px;
            border-radius: 4px;
            padding-left: 15px;
            margin-left: 10px;
            border: 1px solid #DCDFE6;
            outline: none; // 去除选中状态边框
          }
          .account_set{
            color: #409EFF;
            cursor: pointer;
            width: 50px;
            margin-left: 10px;
          }
        }
        .date_collection_box{
          
        }
        .remarks_box{
          textarea{
            overflow: auto;
            resize: vertical;
            width: 210px;
            font-size: 14px;
            line-height: 1.5;
            margin-left: 10px;
            outline: none;
            border: 1px solid #C0C4CC;
            border-radius: 4px;
          }
        }
      }
    }
    .accountSetMask{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 4;
      background-color: rgba(51, 51, 51, 0.5);
      .account_box{
        width: 400px;
        height: 300px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        .title_box{
          text-align: left;
          padding: 10px;
          margin-bottom: 10px;
        }
        .account_content_box{
          border: 1px solid #DCDFE6;
          padding: 10px;
          max-height: 180px;
          overflow-y: auto;
          margin-bottom: 10px;
          div{
            display: flex;
            justify-content: space-around;
            margin-bottom: 10px;
            .delete{
              color: red;
              cursor: pointer;
            }

          }
        }
        .add_accound_box{
          input{
             width: 217px;
            height: 40px;
            border-radius: 4px;
            padding-left: 15px;
            margin-left: 10px;
            border: 1px solid #DCDFE6;
            outline: none; // 去除选中状态边框
          }
          span{
            margin-left: 10px;
            cursor: pointer;
             color: #409EFF;
          }
        }
      }
    }
   .mask{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      background-color: rgba(51, 51, 51, 0.5);
      .collection_box{
        width: 420px;
        // height: 350px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        padding-bottom: 20px;
        div{
          // border: 1px solid red;
          text-align: left;
          padding-left: 10px;
        }
        .title_box{
          text-align: left;
          padding: 10px;
          margin-bottom: 10px;
          >span{
            >span:nth-child(2){
              margin-left: 40px;
            }
          }
        }
        .amount_collected_box{
          >span:nth-of-type(2){
            margin-left: 10px;
          }
        }
        div:not(:first-child){
          height: 40px;
          line-height: 40px;
          display: flex;
          justify-content: flex-start;
          margin-bottom: 20px;
          >span{
            width: 80px;
            display: inline-block;
            // border: 1px solid red;
          }
          input{
            width: 217px;
            height: 40px;
            border-radius: 4px;
            padding-left: 15px;
            margin-left: 10px;
            border: 1px solid #DCDFE6;
            outline: none; // 去除选中状态边框
          }
          .account_set{
            color: #409EFF;
            cursor: pointer;
            width: 50px;
            margin-left: 10px;
          }
        }
        .date_collection_box{
          
        }
      }
      .account_box{
        width: 400px;
        height: 300px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        .title_box{
          text-align: left;
          padding: 10px;
          margin-bottom: 10px;
        }
        .account_content_box{
          border: 1px solid #DCDFE6;
          padding: 10px;
          max-height: 180px;
          overflow-y: auto;
          margin-bottom: 10px;
          div{
            display: flex;
            justify-content: space-around;
            margin-bottom: 10px;
            .delete{
              color: red;
              cursor: pointer;
            }

          }
        }
        .add_accound_box{
          input{
             width: 217px;
            height: 40px;
            border-radius: 4px;
            padding-left: 15px;
            margin-left: 10px;
            border: 1px solid #DCDFE6;
            outline: none; // 去除选中状态边框
          }
          span{
            margin-left: 10px;
            cursor: pointer;
             color: #409EFF;
          }
        }
      }
      .collection_records_box{
        width: 600px;
        height: 300px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        .title_box{
          text-align: left;
          padding: 10px;
          margin-bottom: 10px;
        }
        .collection_records_content_box{
          // border: 1px solid red;
          border: 1px solid #DCDFE6;
          padding: 10px 10px 0 10px;
          max-height: 200px;
          overflow-y: auto;
          div{
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span{
              // margin-right: 20px;
              span:nth-child(1){
                margin-right: 10px;
              }
            }
            .records_remark_box{
              display: inline-block;
              width: 120px;
              overflow: hidden;
              text-overflow:ellipsis; 
              white-space: nowrap;
              text-align: left;
            }
          }
        }
      }
      .logistics_box{
        width: 400px;
        height: 260px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        .title_box{
          text-align: left;
          padding: 10px;
          margin-bottom: 10px;
        }
        >div:not(:first-child){
          height: 40px;
          line-height: 40px;
          display: flex;
          justify-content: flex-start;
          margin-bottom: 10px;
          // border: 1px solid red;
          padding: 0 20px;
          span{
            width: 80px;
            display: inline-block;
            // border: 1px solid red;
          }
          input{
            width: 217px;
            height: 40px;
            border-radius: 4px;
            padding-left: 15px;
            margin-left: 10px;
            border: 1px solid #DCDFE6;
            outline: none; // 去除选中状态边框
          }
          
        }
      }
      .order_state_box{
        width: 400px;
        height: 260px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 10px;
        div{
          border: 1px solid red;
          // padding: 5px 10px;
          width: 50px;
          height: 32px;
          line-height: 32px;
          border-radius: 6px;
          // margin-right: 50px;
        }
        div:not(:nth-child(3n)){
          // margin-right: 50px;
        }
      }
      
   }
}
</style>